/* global apigClientFactory PRODUCTION */

/* @ngInject */
export default class {
  constructor(angularAuth0, store, jwtHelper, $q, $cookies, $log, $location, $window, HelperClass) {
    this.angularAuth0 = angularAuth0;
    this.apiClient = apigClientFactory.newClient(); // Has to add because of circular structure
    this.store = store;
    this.jwtHelper = jwtHelper;
    this.$q = $q;
    this.$cookies = $cookies;
    this.$log = $log;
    this.$location = $location;
    this.$window = $window;
    this.HelperClass = HelperClass;
    this.openUrls = [
      'authIdTypeGet',
      'authIdTypePost',
      'companiesIdTypeGet',
      'eventsGet',
      'coursesGet',
      'eventsIdGet',
      'coursesIdGet',
      'eventsIdTypeTypeIdGet',
      'eventsIdTypeTypeIdPost',
      'coursesIdTypeTypeIdPost',
      'eventsIdTypePut',
      'coursesIdTypePut',
      'productsIdPost',
      'productsGet'
    ];
    this.authToken = store.get('token') || $cookies.get('__prolaera_access_token') || undefined;
    this.refreshToken = store.get('refreshToken') || $cookies.get('__prolaera_refresh_token') || undefined;
    this.Auth0TokenRenewPromise = false;
    this.CognitoTokenRenewPromise = false;
  }

  get getAuthToken() {
    if (!this.authToken) this.setTokens();
    return this.authToken;
  }
  get getRefreshToken() {
    if (!this.refreshToken) this.setTokens();
    return this.refreshToken;
  }

  setTokens() {
    this.authToken = this.store.get('token') || this.$cookies.get('__prolaera_access_token') || undefined;
    this.refreshToken = this.store.get('refreshToken') || this.$cookies.get('__prolaera_refresh_token') || undefined;
  }

  resetTokens() {
    this.store.remove('token');
    this.store.remove('refreshToken');
    this.store.remove('user_id');
    this.store.remove('expires_at');
    this.$cookies.remove('__prolaera_access_token', { domain: '.prolaera.com', path: '/' });
    this.$cookies.remove('__prolaera_refresh_token', { domain: '.prolaera.com', path: '/' });
    this.authToken = undefined;
    this.refreshToken = undefined;
  }

  endSession() {
    this.Auth0TokenRenewPromise = false;
    this.CognitoTokenRenewPromise = false;
    this.store.remove('state');
    this.store.remove('stateParams');
    this.store.remove('surgentEvents');
    this.store.remove('surgentCourses');
    this.store.remove('tempUsers');
    this.resetTokens();
  }

  renewAuth0Token() {
    // Return existing promise for refreshing Auth0 Token
    if (
      this.Auth0TokenRenewPromise &&
      this.Auth0TokenRenewPromise.$$state &&
      !this.Auth0TokenRenewPromise.$$state.status
    ) {
      return this.Auth0TokenRenewPromise;
    }

    // Create new promise for Auth0 Token
    this.Auth0TokenRenewPromise = this.$q((resolve, reject) => {
      this.angularAuth0.checkSession(
        {
          connection: 'Username-Password-Authentication',
          responseType: 'token',
          scope: 'openid email user_id offline_access'
        },
        (error, authResult) => {
          if (error) {
            this.$log.error('JwtClass.renewAuth0Token', error);
            this.$window.location.href = '/logout';
            return reject(error);
          }
          this.setAuth0Session(authResult);
          resolve(authResult.idToken);

          // Reset promise after resolved.
          this.Auth0TokenRenewPromise = false;
        }
      );
    });

    return this.Auth0TokenRenewPromise;
  }

  renewCognitoToken() {
    // Return existing promise for refreshing Cognito Token
    if (this.CognitoTokenRenewPromise && !this.CognitoTokenRenewPromise.status) {
      return this.CognitoTokenRenewPromise;
    }

    // Create new promise for Cognito Token
    this.CognitoTokenRenewPromise = this.$q((resolve, reject) => {
      const id = this.HelperClass.getSubDomain();
      const refresh_token = this.getRefreshToken;

      this.apiClient
        .authIdTypePut(
          {
            id,
            type: 'refresh_token'
          },
          {
            refresh_token
          }
        )
        .then(({ data: { tokens } }) => {
          this.setCognitoSession(tokens);

          resolve(tokens.access_token);

          // Reset promise after resolved.
          this.CognitoTokenRenewPromise = false;
        })
        .catch(error => {
          this.$log.error('JwtClass.renewCognitoToken', error);
          this.$window.location.href = '/logout';
          reject(error);
        });
    });

    return this.CognitoTokenRenewPromise;
  }

  setAuth0Session({ expiresIn, idToken, refreshToken, idTokenPayload: { user_id } }) {
    // Set the time that the Access Token will expire at
    const expiresAt = JSON.stringify(expiresIn * 1000 + new Date().getTime());
    this.authToken = idToken;
    this.store.set('token', idToken);
    this.store.set('refreshToken', refreshToken);
    this.store.set('user_id', user_id);
    this.store.set('expires_at', expiresAt);
  }

  setCognitoSession({ access_token, refresh_token, expires_in }) {
    if (!access_token) return;
    this.authToken = access_token;
    this.store.set('token', access_token);
    this.store.set('expires_at', expires_in);
    if (refresh_token) this.store.set('refreshToken', refresh_token);
  }

  setMsTeamsSsoSession({ access_token, refresh_token, expires_in }) {
    if (!access_token) return;
    this.authToken = access_token;
    this.store.set('token', access_token);
    this.store.set('expires_at', expires_in);
    if (refresh_token) this.store.set('refreshToken', refresh_token);
  }

  status(key) {
    const token = this.getAuthToken;
    const refreshToken = this.getRefreshToken;

    if (!token && !refreshToken && this.openUrls.includes(key)) {
      return this.$q.resolve(undefined);
    }

    if (!token || !refreshToken) {
      this.resetTokens();
      return this.$q.reject('No token found');
    }

    if (this.jwtHelper.isTokenExpired(token)) {
      if (token.startsWith('Bearer')) return this.renewCognitoToken();
      return this.renewAuth0Token();
    }
    return this.$q.resolve(token);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/JwtClass.js